import _ from "lodash";
import Vue from "vue";

// Please note these ranges must match what's configured in tailwind
const BREAK_POINTS = {
    'sm': 576,
    'md': 768,
    'lg': 992,
    'xl': 1200,
}
const BREAK_POINT_NAMES = Object.keys(BREAK_POINTS);

/**
 * @returns {'xl'|'lg'|'md'|'sm'}
 */
const getBreakPoint = () => {
    const width = window.innerWidth;
    return Object.keys(BREAK_POINTS)
               .find((bp) => width < BREAK_POINTS[bp]) || 'xl';
};

const currentBreakPoint = Vue.observable({ breakPoint: getBreakPoint() })

window.addEventListener(
    'resize',
    () => {
        currentBreakPoint.breakPoint = getBreakPoint();
    }
)

export default {
    methods: {
        getBreakpoint: () => currentBreakPoint.breakPoint,

        /**
         * @param {'xl'|'lg'|'md'|'sm'} breakPoint
         * @return True if the current page is this break point or bigger
         */
        isBreakPointUp(breakPoint) {
            if (!BREAK_POINT_NAMES.includes(breakPoint)) throw new Error(`No such break point ${breakPoint}`);
            return BREAK_POINT_NAMES.indexOf(currentBreakPoint.breakPoint) >= BREAK_POINT_NAMES.indexOf(breakPoint)
        },
        /**
         * @param {'xl'|'lg'|'md'|'sm'} breakPoint
         * @return True if the current page is this break point or smaller
         */
        isBreakPointDown(breakPoint) {
            if (!BREAK_POINT_NAMES.includes(breakPoint)) throw new Error(`No such break point ${breakPoint}`);
            return BREAK_POINT_NAMES.indexOf(currentBreakPoint.breakPoint) <= BREAK_POINT_NAMES.indexOf(breakPoint)
        },
    }
}